var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7496 15.3456C28.7496 14.3259 28.6698 13.3007 28.4995 12.2976H14.8389V18.0738H22.6616C22.337 19.9368 21.294 21.5848 19.7667 22.632V26.3799H24.4337C27.1744 23.7674 28.7496 19.9092 28.7496 15.3456Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8389 30.0009C18.7449 30.0009 22.039 28.6726 24.4391 26.3797L19.772 22.6318C18.4735 23.5467 16.7972 24.0648 14.8442 24.0648C11.0659 24.0648 7.86225 21.4248 6.71279 17.8752H1.89673V21.7389C4.35531 26.8041 9.36295 30.0009 14.8389 30.0009Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7073 17.8754C6.10063 16.0124 6.10063 13.9952 6.7073 12.1322V8.26855H1.89656C-0.157578 12.507 -0.157578 17.5006 1.89656 21.7391L6.7073 17.8754Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8389 5.93708C16.9037 5.90401 18.8993 6.70871 20.3946 8.18584L24.5295 3.90327C21.9113 1.35688 18.4363 -0.0430825 14.8389 0.00101083C9.36295 0.00101083 4.35531 3.19778 1.89673 8.26851L6.70746 12.1322C7.85161 8.57716 11.0605 5.93708 14.8389 5.93708Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.9655,
    height: 30,
    fill: "white",
    transform: "translate(0.0664062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.b80c2670.svg";
export { ForwardRef as ReactComponent };